import {
  InspectionSetDTO,
  IWellImageDTO,
  ScoresOfWellDropsDTO,
  WellImageDTO,
} from 'business/models/Models';
import { WellIng } from '../Experiment/constants';
import { CaptureProfileOption } from './ReportsConstants';

export interface IWellImageWithInfoDTO extends IWellImageDTO {
  inspectionSet: InspectionSetDTO;
  score: ScoresOfWellDropsDTO;
  wellInfo: WellIng;
  cp: CaptureProfileOption;
  isSelectedInspection: boolean;
}

export class WellImageWithInfoDTO extends WellImageDTO implements IWellImageWithInfoDTO {
  inspectionSet: InspectionSetDTO;
  score: ScoresOfWellDropsDTO;
  wellInfo: WellIng;
  cp: CaptureProfileOption;
  dropNumber: number;
  isSelectedInspection: boolean;

  constructor(data?: IWellImageWithInfoDTO | WellImageDTO) {
    if (data instanceof WellImageDTO) {
      super();
    } else {
      super(data);
    }
    this.init(data);
  }

  override init(_data?: any): void {
    super.init(_data);
    if (_data) {
      this.inspectionSet = _data.inspectionSet;
      this.score = _data.score;
      this.wellInfo = _data.wellInfo;
      this.cp = _data.cp;
      this.isSelectedInspection = _data.isSelectedInspection;
    }
  }

  static override fromJS(data: any): WellImageWithInfoDTO {
    data = typeof data === 'object' ? data : {};
    const result = new WellImageWithInfoDTO();
    result.init(data);
    return result;
  }

  override toJSON(data: any) {
    return {
      ...super.toJSON(),
      latestInspectionSet: this.inspectionSet,
      score: this.score,
      wellInfo: this.wellInfo,
      cp: this.cp,
      isSelectedInspection: this.isSelectedInspection,
    };
  }
}
